import {FC} from 'react';

interface Props {
  size?: number;
}

export const SvgDarkIcon: FC<Props> = ({size = 64}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 743.4 224.16"
      width={size}
      height={size * (224.16 / 743.4)} // Maintain aspect ratio
    >
      <defs>
        <style>{'.cls-1{fill:#f13c4f;}'}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M341.53,24.26V0h-160V30.93H295l-114.18,165v24.86H345.17V190.14h-118Z" />
          <path d="M703.47,210.59q-7.82,5.68-20.7,5.69-14.47,0-23.2-6.75t-8.72-18.43h-9.32a30.14,30.14,0,0,0,5,17.21q5,7.51,14.78,11.68a53.91,53.91,0,0,0,21.42,4.17q17.06,0,27.48-7.88a25,25,0,0,0,10.43-20.93A26.06,26.06,0,0,0,716.81,181a32.19,32.19,0,0,0-11.52-10.42q-7.66-4.36-22.52-8.42t-21.61-9.38a16.75,16.75,0,0,1-6.75-13.75,17.64,17.64,0,0,1,7.51-14.76q7.5-5.67,20.17-5.67,13,0,20.77,6.89t7.74,18.21H720a31,31,0,0,0-4.77-16.91A32.32,32.32,0,0,0,701.76,115a44.19,44.19,0,0,0-19.67-4.24q-16.23,0-26.65,7.92T645,139.25q0,13,11.22,21.07,7.88,5.69,25,10.5T704.84,181q6.43,5.36,6.44,14.52a17.77,17.77,0,0,1-7.81,15.09m-72.82-98.33H545.74v7.88h37.75v102.5h9.33V120.14h37.83ZM501.5,123.63l22.14,60.12H479.36Zm36.55,99h9.7L506,112.26h-8.86L455.33,222.64h9.78l11.37-31H526.6Zm-100-60.8H386.45v-41.7h59v-7.88H377.13V222.64h68.69v-7.88H386.45v-45h51.63Z" />
          <rect
            className="cls-1"
            x="0.02"
            y="91.43"
            width="129.55"
            height="30.85"
          />
          <path d="M734.79,126.83h-1.07l-.92-.12a9.18,9.18,0,0,1-7.64-9.95,8.72,8.72,0,0,1,2.27-5.15,9,9,0,0,1,6.46-3.06,8.43,8.43,0,0,1,4.22.85,9,9,0,0,1,5.15,6.69c.07.35.1.7.14,1.06v1.07c0,.23,0,.47-.08.7a8.93,8.93,0,0,1-2.2,4.79,9,9,0,0,1-5.29,3C735.49,126.75,735.14,126.78,734.79,126.83Zm-.54-15.78a6.63,6.63,0,1,0,6.63,6.63A6.66,6.66,0,0,0,734.25,111.05Z" />
          <path d="M731.12,113.5h1.94c.59,0,1.18,0,1.77,0a2.89,2.89,0,0,1,2.34,1.37,3.1,3.1,0,0,1,.36,2.15,2.73,2.73,0,0,1-1.18,1.89l-.08.06,2.06,2.83h-2a.29.29,0,0,1-.25-.13l-1.51-2.08a.27.27,0,0,0-.25-.13c-.46,0-.92,0-1.41,0v2.32h-1.76Zm1.77,4.28c.63,0,1.24,0,1.85-.07,1-.13,1.22-.87,1-1.68a1,1,0,0,0-.93-.7c-.62,0-1.25,0-1.87,0l0,0Z" />
          <rect width="143.29" height="30.53" />
          <rect y="190.93" width="144.35" height="29.84" />
        </g>
      </g>
    </svg>
  );
};

export default SvgDarkIcon;
